import { render, staticRenderFns } from "./FormsReports.vue?vue&type=template&id=12452dd5"
import script from "./FormsReports.vue?vue&type=script&lang=js"
export * from "./FormsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports